module.exports = __webpack_public_path__ + "img/user-outline.cc31f2ae.svg";